import { SCOUT } from 'constants/game-types';
import { manageFavoritesPage } from 'constants/page-names';
import { PREMIUM, PREMIUM_PLUS, productToPath } from 'containers/product-initializer/products';

export const generatePlayerGameLink = (playerId: number, gameId: number) =>
    `${productToPath[SCOUT].path}/players/${playerId}/videos?gameId=${gameId}`;
export const generatePlayerLink = (playerId: number) => `${productToPath[SCOUT].path}/players/${playerId}`;
export const generateTeamLink = (teamId: number) => `${productToPath[PREMIUM].path}/team/${teamId}`;
// Premium Plus goes to the Premium page, as the profile menu and the home favorites panel do.
// TODO: lite.js (Premium Plus) has its own manage favorites route — should Premium Plus stay on it?
export const generateManageFavoritesLink = (product: keyof typeof productToPath) =>
    `${productToPath[product === PREMIUM_PLUS ? PREMIUM : product].path}/${manageFavoritesPage}`;
export const FAV_AND_RECENT_TYPE_TEAM = 'TEAM';
export const FAV_AND_RECENT_TYPE_SCOUT_PLAYER = 'SCOUT_PLAYER';
export const FAV_AND_RECENT_TYPE_EVENT = 'EVENT';
export const FAVORITES_PAYERS_RECORD_SIZE = 1000;
export const REFETCH_TEAM_AND_PLAYER_TIMEOUT = 1000;
export const TEAMS_CLIENTS_RECORD_SIZE = 100000;
export const PLAYER_TEAM_LOGO_SIZE = 48;
export const TEAM_LOGO_SIZE = 26;
